module.exports = __webpack_public_path__ + "img/Archiv_2017_1.97c5679e.jpeg";